import { render, staticRenderFns } from "./TitleSidebar.vue?vue&type=template&id=a55c5ab2&"
import script from "./TitleSidebar.vue?vue&type=script&lang=js&"
export * from "./TitleSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports